module.exports = __webpack_public_path__ + "components/collaborations-header/static/header--large-44427fe9986b7146c3f7495c0d6381c3.jpg";